import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PeoplesoftReaderForm from '../forms/peoplesoft-reader-form';
import { peoplesoftReaderValidationSchema } from '../schema/peoplesoftReader.js';

export default function PeoplesoftReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'PeopleSoft Reader Node Details',
        altText: 'PeopleSoft Reader Node',
        defaultLabel: 'PeopleSoft Reader Node',
      }}
    >
      <CommonNode
        FormComponent={PeoplesoftReaderForm}
        schemaResolver={peoplesoftReaderValidationSchema}
      />
    </NodeProvider>
  );
}
